export const MAX_SIZE_UPLOAD_REGISTER_BRAND_NAME = 52428800;
export const MAX_SIZE_UPLOAD_CSV = 26214400;

export const FILE_TYPE = {
    CSV: 'csv',
    XLS: 'xls',
    XLSX: 'xlsx',
    ZIP: 'zip',
    RAR: 'rar',
};

export const ACCEPT_FILE_TYPE = [FILE_TYPE.ZIP, FILE_TYPE.RAR];

export const ACCEPT_FILE_TYPE_IN_HTML = `.${FILE_TYPE.ZIP},.${FILE_TYPE.RAR}`;

export const ACCEPT_FILE_TYPE_EXCEL = [
    FILE_TYPE.CSV,
    FILE_TYPE.XLS,
    FILE_TYPE.XLSX,
];

export const ACCEPT_FILE_TYPE_EXCEL_IN_HTML = `.${FILE_TYPE.CSV},.${FILE_TYPE.XLS},.${FILE_TYPE.XLSX}`;

export const CUSTOMER_TEMPLATE_NAME = 'customer-template.csv';
export const MAX_NUMBER_OF_SMS = 5;

export const CREATE_SMS_STEP = {
    STEP_1: 0,
    STEP_2: 1,
    STEP_3: 2,
};

export const IMPORT_CSV_STEP = {
    STEP_1: 0,
    STEP_2: 1,
    STEP_3: 2,
    STEP_4: 3,
};

export const SEND_SMS_MANUAL_GROUP_KEY = 'manual';
export const SEND_SMS_SCHEDULE_TYPE = {
    NOW: {
        key: 'NOW',
        value: 'NOW',
        label: 'sms.now',
    },
    BIRTHDAY: {
        key: 'BIRTHDAY',
        value: 'BIRTHDAY',
        label: 'sms.birthday_message',
    },
    TIMER: {
        key: 'TIMER',
        value: 'TIMER',
        label: 'sms.date',
    },
};

export const TABLE_CUSTOMER_KEY = {
    FULL_NAME: {
        key: 'name',
        label: 'Fullname',
    },
    PHONE_NUMBER: {
        key: 'phoneNumber',
        label: 'Phone number',
    },
    DATE_OF_BIRTH: {
        key: 'birthday',
        label: 'Date of birth',
    },
};

export const SMS_SERVICES_STATUS = {
    DONE: {
        key: 'DONE',
        label: 'Done',
        value: 'DONE',
        className: 'bg-maya-blue',
        variant: 'light-sea-green',
    },
    PROCESSING: {
        key: 'PROCESSING',
        label: 'Processing',
        value: 'PROCESSING',
        className: 'bg-golden-dream',
        variant: 'yellow-orange',
    },
    FAILED: {
        key: 'FAILED',
        label: 'Failed',
        value: 'FAILED',
        className: 'bg-mortar',
        variant: 'grey',
    },
    PENDING: {
        key: 'PENDING',
        label: 'Pending',
        value: 'PENDING',
        className: 'bg-chino',
        variant: 'scarlet',
    },
    CANCELLED: {
        key: 'CANCELLED',
        label: 'Cancelled',
        value: 'CANCELLED',
        className: 'bg-silver',
        variant: 'grey',
    },
};
export const EXPORT_REPORT_RECEIVERS_NAME = 'Customers_receivers.xlsx';

export const BRAND_NAME_TYPES = {
    INTERNATIONAL: {
        key: 'INTERNATIONAL',
        value: 'International',
        className: '',
    },
    CAMBODIA: {
        key: 'CAMBODIA',
        value: 'Cambodia',
        className: '',
    },
};

export const SMS_TRANSACTION_DETAIL_STATUS = {
    SUCCESS: {
        key: 'SUCCESS',
        label: 'Success',
        value: 'SUCCESS',
        className: 'text-success',
        variant: 'light-sea-green',
    },
    FAILED: {
        key: 'FAILED',
        label: 'Failed',
        value: 'FAILED',
        className: 'text-danger',
        variant: 'grey',
    },
    CANCELLED: {
        key: 'CANCELLED',
        label: 'Cancelled',
        value: 'CANCELLED',
        className: 'text-regent-grey',
        variant: 'grey',
    },
};

export const SMS_STATUS_ALLOWED_CANCEL = [
    SMS_SERVICES_STATUS.PROCESSING.key,
    SMS_SERVICES_STATUS.PENDING.key,
];

export const SMS_TYPE_ALLOWED_CANCEL = [
    SEND_SMS_SCHEDULE_TYPE.BIRTHDAY.key,
    SEND_SMS_SCHEDULE_TYPE.TIMER.key,
];
